import clsx from "clsx";

export function getTodoCheckboxClasses(priority?: number) {
  return {
    wrapper: clsx({
      "before:border-danger-500 after:bg-danger-500": priority === 1,
      "before:border-warning-500 after:bg-warning-500": priority === 2,
      "before:border-success-500 after:bg-success-500": priority === 3,
      "before:border-default-200": !priority || priority === 4,
    }),
  };
}

export function getTodoDueDateClasses(formattedDueDate: string | null) {
  return clsx("text-default-500 flex text-xs italic", {
    "text-green-500!": formattedDueDate?.includes("tomorrow"),
    "text-red-400!": formattedDueDate?.includes("overdue"),
    "text-yellow-500!": formattedDueDate?.includes("today"),
  });
}
